import component         from '@/components/stat/CompanyPayments.vue'
const menuId = 'rp1'
const routes = [
    
    {
        path        : '/payments',
        name        : 'countersCheck',
        
        component   : component,
        meta        : { name : 'Controllo Casse', visible : true ,icon : 'fas fa-cash-register',color:'#336600',menu:menuId},

    },
      
        
]
export default routes